export interface QueryData {
  count: number
  users: User[]
}

interface Transaction {
  account: string
  amount: number
  type: string
  code: string
  bankRefNumber: string
  text: string[]
  customerRefNumber: string
  date: string
}

export interface User {
  date: string
  account_number: string
  total_credits: number | null
  total_debits: number | null
  opening_ledger: number | null
  closing_ledger: number | null
  opening_available: number | null
  transactions: Transaction[]
  group_name: string
  group_number: string
}

export const GroupStatus: Record<number, string> = {
  1: 'Update'
} as const

export const BalanceType = {
  opening_ledger: 'Opening Ledger',
  closing_ledger: 'Closing Ledger',
  opening_available: 'Opening Available',
  average_closing_available: 'Average Closing Available MTD',
  total_float: 'Total Float',
  one_day_float: '1-Day Float',
  two_more_days_float: '2 or More Days Float',
  total_credits: 'Total Credits',
  total_debits: 'Total Debits'
} as const

export interface ExpandedRowProps {
  row: Transaction[]
}

export interface Filter {
  group_name?: string
  group_number?: string
  account_number?: string
  date?: Date
  sort?: keyof User
  order?: 'ASC' | 'DESC'
  page: number
  perPage: number
}
